<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      :cols="columnas"
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
    ></tablita>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "empresas_id",
        label: "Empresa Naviera",
        busqueda: "",
        tipo: "select-loadable",
        ruta: "/empresas",
        parametro: "nombre",
        append_parametro: "&tipo_empresa_ids=3",
        searchable: true,
        path: "empresa_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "tipo_carrocerias_id",
        label: "Tipo Carroceria",
        busqueda: "",
        tipo: "select-loadable",
        ruta: "/tipo_carrocerias",
        parametro: "nombre",
        append_parametro: "",
        searchable: true,
        path: "tipo_carroceria_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "vigente_desde",
        label: "Vigente Desde",
        busqueda: "",
        tipo: "date",
        searchable: true,
        path: "vigente_desde",
      },
      {
        key: "vigente_hasta",
        label: "Vigente Hasta",
        busqueda: "",
        tipo: "date",
        searchable: true,
        path: "vigente_hasta",
      },
      {
        key: "valor",
        label: "Valor (Pesos)",
        busqueda: "",
        tipo: "number",
        searchable: true,
        path: "valor",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 6,
        tipo: "select-loadable",
        key: "empresas_id",
        valor: "",
        label: "Empresa Naviera (*)",
        busqueda: "",
        ruta: "/empresas",
        parametro: "nombre",
        append_parametro: "&tipo_empresa_ids=3",
        disabled: false,
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        cols: 6,
        tipo: "select-loadable",
        key: "tipo_carrocerias_id",
        valor: "",
        label: "Tipo Carroceria (*)",
        busqueda: "",
        ruta: "/tipo_carrocerias",
        parametro: "nombre",
        disabled: false,
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        cols: 4,
        tipo: "datetime",
        key: "vigente_desde",
        valor: "",
        label: "Vigente Desde (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "datetime",
        key: "vigente_hasta",
        valor: "",
        label: "Vigente Hasta",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "numero",
        key: "valor",
        valor: "",
        label: "Valor (Peso) (*)",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Tarifa Transbordador",
      ancho: "xl",
      ruta: "/tarifas_transbordadores",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Tarifas de Transbordadores",
      titulo_boton: "Crear Tarifa",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.$emit("spinner", true);
    this.cargar_empresas_navieras();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_empresas_navieras() {
      await this.axios
        .get(
          `${this.api}/empresas?tipo_empresa_ids=3&limit=99999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.$set(this.columnas[0], "opciones", res.data.data.data);
          this.$set(this.inputs[0], "opciones", res.data.data.data);
        })
        .catch((e) => {
          //alert(e);
        });
      this.cargar_tipo_carrocerias();
    },
    async cargar_tipo_carrocerias() {
      await this.axios
        .get(`${this.api}/tipo_carrocerias?limit=99999999`, this.cabeceras_json)
        .then((res) => {
          this.$set(this.columnas[1], "opciones", res.data.data.data);
          this.$set(this.inputs[1], "opciones", res.data.data.data);
        })
        .catch((e) => {
          //alert(e);
        });
      //this.cargar("");
      this.$emit("cargar");
    },
    async cargar($event) {
      this.$emit("spinner", true);
      this.pagina_actual = `${this.api}/tarifas_transbordadores${$event}`;
      this.lista = [];
      await this.axios
        .get(
          `${this.api}/tarifas_transbordadores${$event}`,
          this.cabeceras_json
        )
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargar_url(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/tarifas_transbordadores`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/tarifas_transbordadores/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },

    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>